<div class="error">
  <ng-content></ng-content>
</div>
